import React, { useEffect, useState } from 'react';
import {
    ProviderClaimTransmission,
} from '../../../..';
import { ITransmissionDetailProps } from './transmission-detail.types';
import { TransmissionEmbeddedPanel } from './transmission-detail-embedded';
import { getTransmissionCobMarkers, TimelineCobMarkers } from '../timeline-cob-markers';

export interface ITransmissionWithPaymentIds {
    paymentIds?: string[];
    statuses?: Array<{ status?: string }>;
}

export const TransmissionStatus: React.FunctionComponent<{
    transmission: ITransmissionWithPaymentIds;
}> = ({ transmission }) => <TimelineCobMarkers {...getTransmissionCobMarkers(transmission)} />;

export const TransmissionDetail: React.FunctionComponent<ITransmissionDetailProps> = (props) => {
    const {
        transmission,
        appType,
        previousTransmission,
        downloadDocument,
        getPayerSubscriber,
        embedded = false,
    } = props;

    const showDiff = !!previousTransmission?.x12 && !!transmission.x12;

    const [payer, setPayer] = useState<any>();
    const [subscriber, setSubscriber] = useState<any>();
    const [documentUrl, setDocumentUrl] = useState<{ url?: string } | undefined>();
    const [loadingPayer, setLoadingPayer] = useState(false);
    const [documentLoading, setDocumentLoading] = useState(false);

    const documentId = transmission.documentId;

    useEffect(() => {
        if (appType !== 'provider' || !getPayerSubscriber) return;
        const id = (transmission as ProviderClaimTransmission).payerSubscriberId;
        if (!id) return;
        setLoadingPayer(true);
        getPayerSubscriber(id)
            .then((res) => {
                if (res) {
                    setPayer(res.payer);
                    setSubscriber(res.subscriber);
                }
            })
            .finally(() => setLoadingPayer(false));
    }, [appType, transmission, getPayerSubscriber]);

    useEffect(() => {
        if (!documentId) return;
        setDocumentLoading(true);
        downloadDocument(documentId)
            .then(setDocumentUrl)
            .finally(() => setDocumentLoading(false));
    }, [documentId, downloadDocument]);

    return (
        <TransmissionEmbeddedPanel
            transmission={transmission}
            appType={appType}
            previousTransmission={previousTransmission}
            payer={payer}
            subscriber={subscriber}
            loadingPayer={loadingPayer}
            statuses={transmission.statuses || []}
            showDiff={showDiff}
            documentLoading={documentLoading}
            documentUrl={documentUrl}
        />
    );
};
